<template>
  <div class="animal">
    <img class="animal-img" src="../../../assets/images/product/animal.png" alt="">
    <div class="animal-text">
      <h4 class="animal-title">智慧牧业</h4>
      <div class="animal-title-border"></div>
      <p>
        在畜牧业发展过程中，从开始的养活，到后续的养好，再到现在的多样性畜牧模式，不同种类、不同品种的畜牧作物，伴随而来的问题，就是针对大规模、多样化的养殖场，难以形成准确高效的畜牧作物的信息实时监控管理，对畜牧业未来发展存在多种阻碍。通过RFID、耳标、智能投喂系统、环境监控系统、健康监测系统等系统实现畜牧业智能化改造，达到提升养殖效果、优化养殖流程、简化维护步骤，降低人工成本的效果。
      </p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.animal {
  padding-top: 80px;
  min-height: 100vh;
  position: relative;
}

.animal-img {
  width: 49vw;
  height: 42vh;
  min-height: 541px;
  position: absolute;
  top: 13.6%;
  left: 0;
  z-index: 1;
}

.animal-text {
  width: 57.4vw;
  height: 47.9vh;
  min-height: 607px;
  background: #ffffff;
  border-radius: 10px;
  position: absolute;
  top: 13.6%;
  left: 32.9%;
  text-align: left;
  padding-left: 19%;
  .animal-title {
  font-size: 40px;
  font-weight: 500;
  color: #323232;
  margin-top: 94px;
}

.animal-title-border {
  width: 75px;
  height: 2px;
  background: #d00001;
  margin: 11px 0 39px;
}
  p{
    width: 80%;
    color: #808080;
    font-size: 20px;
    line-height: 2;
    text-align: justify;
    /*兼容ie*/
    text-justify: distribute-all-lines;
  }
}


</style>